import { apiClient } from '@/api/client'
import type { MyEntitlements } from '@/features/entitlements/types'

export const entitlementsApi = {
  async getMine(): Promise<MyEntitlements> {
    const { data } = await apiClient.get<MyEntitlements>('/me/entitlements')
    return data
  },
}
